// src/app/carga-masiva-productos/carga-masiva-productos.component.ts

import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
    columnasCoadyuvantes,
    columnasAlimentoBalanceado,
    columnasAcondicionadorEnmienda,
    TipoProductoId,
} from './assets/columnas-producto.constants';
import { TipoProductoService } from './services/tipo-producto.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-carga-masiva-productos',
    templateUrl: './carga-masiva-productos.component.html',
    styleUrls: ['./carga-masiva-productos.component.css'],
})
export class CargaMasivaProductosComponent {
    // El control almacena el id del tipo de producto, no su nombre, para que el
    // flujo no dependa del texto visible (HU130).
    tipoProductoControl: FormControl = new FormControl(
        TipoProductoId.Fertilizante
    );
    columnas: any[] = [];
    tiposProducto;
    formulario: FormGroup = new FormGroup({
        tipoProducto: this.tipoProductoControl,
    });

    constructor(
        private tipoProductoService: TipoProductoService,
        private translate: TranslateService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
        this.tipoProductoControl.valueChanges.subscribe(() => {
            this.actualizarColumnas();
        });
    }

    async ngOnInit() {
        this.tiposProducto =
            await this.tipoProductoService.loadOptTypeProduct();
        if (this.tiposProducto && this.tiposProducto.length > 0) {
            // Establecer el valor de tipoProducto al primer elemento disponible.
            this.tipoProductoControl.setValue(
                String(this.tiposProducto[0].id)
            );
        }
    }

    async actualizarColumnas() {
        switch (String(this.tipoProductoControl.value)) {
            case TipoProductoId.Plaguicida:
                this.columnas =
                    await this.tipoProductoService.getColumnsPlaguicida();
                break;
            case TipoProductoId.Fertilizante:
                this.columnas =
                    await this.tipoProductoService.getColumnsFertilizante();
                break;
            case TipoProductoId.Coadyuvante:
                this.columnas = columnasCoadyuvantes;
                break;
            case TipoProductoId.NutricionAnimal:
                this.columnas = columnasAlimentoBalanceado;
                break;
            case TipoProductoId.AcondicionadorEnmienda:
                this.columnas = columnasAcondicionadorEnmienda;
                break;
            default:
                this.columnas =
                    await this.tipoProductoService.getColumnsFertilizante();
                break;
        }
    }
}
